import { useTranslation } from '@mint-lib/i18n';
import { useQueryClient } from '@mint-lib/query-client';
import { Button } from '@mint-lib/tw-components';
import { Alert } from '@mint-lib/tw-components/patterns';
import { Auth } from '@mint-sdk/api-auth';

const RecipientsCommentsTabError = () => {
  const { t } = useTranslation('@mint-lib/approval-flow-circuit_v2');
  const queryClient = useQueryClient();

  const handleRetry = () => {
    queryClient.resetQueries({
      queryKey: Auth.listUsersShort({
        params: {},
      }).queryKey,
    });
  };

  return (
    <Alert
      severity="error"
      title={t('Failed to retrieve the list of emails.')}
      variant="inline"
      removable={false}
    >
      <Button
        data-dd-action-name="Retry action"
        size="small"
        variant="outlined"
        type="button"
        onClick={handleRetry}
      >
        {t('Try again')}
      </Button>
    </Alert>
  );
};

export default RecipientsCommentsTabError;
